import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { name } from 'settings';
import { APIHandler } from 'C4';

export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
    };
  }

  toggle(diplomaLoaded) {
    this.setState({ diplomaLoaded });
  }

  render() {
    const { appId, firstName, lastName } = this.props;

    const image = `https://accounts.travpromobile.com/diploma_api?firstName=${firstName}&lastName=${lastName}&appID=${appId}`;
    const subject = encodeURIComponent(`${name} diploma`);
    const body = encodeURIComponent(image);

    return (
      <div
        style={{ display: 'none' }}
        id="diploma"
        className="fancybox-share diploma"
      >
        <img
          className="diploma__image"
          name="diploma"
          src={image}
          alt="diploma"
        />
        {firstName === 'Preview' &&
          <div className="support">
            Something went wrong. <br /><br />Please contact support at <a href="mailto:info@travpromobile.com">info@travpromobile.com</a> or <a href="https://travpromobile-kb-05222019.groovehq.com/help/" target="_blank">click here</a> with the following information: email, first name, last name and in which app the issue occurred. We will try to respond as soon as possible.
          </div>
        }
        <div className="buttons__diploma">
          <a
            href={`/print/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${appId}`}
            disabled={!this.state.diplomaLoaded}
            className="fancybox-share__button fancybox-share__button--fb"
          >
            <FontAwesomeIcon icon={['fas', 'print']} />
            {i18n.translate('reportCard.print')}
          </a>
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'at']} />
            <span>{i18n.translate('reportCard.email')}</span>
          </a>
          <a
            href={APIHandler.getDownloadURL(image)}
            download={`${subject}.png`}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'download']} />
            <span>{i18n.translate('reportCard.download')}</span>
          </a>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  appId: -1,
  firstName: '',
  lastName: '',
};
